(() => {
      const header = document.getElementById('siteHeader');
      const progress = document.getElementById('progressBar');
      const menuButton = document.getElementById('menuButton');
      const mobileMenu = document.getElementById('mobileMenu');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const updateScroll = () => {
        const y = window.scrollY;
        const max = document.documentElement.scrollHeight - window.innerHeight;
        header.classList.toggle('scrolled', y > 16);
        progress.style.width = `${max > 0 ? (y / max) * 100 : 0}%`;
      };

      const isMenuOpen = () => menuButton.getAttribute('aria-expanded') === 'true';
      const closeMenu = ({ returnFocus = false } = {}) => {
        if (!isMenuOpen()) return;
        menuButton.setAttribute('aria-expanded', 'false');
        menuButton.setAttribute('aria-label', 'Open navigation');
        mobileMenu.classList.remove('open');
        document.body.classList.remove('menu-open');
        if (returnFocus) menuButton.focus();
      };

      menuButton.addEventListener('click', () => {
        if (isMenuOpen()) { closeMenu({ returnFocus: true }); return; }
        menuButton.setAttribute('aria-expanded', 'true');
        menuButton.setAttribute('aria-label', 'Close navigation');
        mobileMenu.classList.add('open');
        document.body.classList.add('menu-open');
        const first = mobileMenu.querySelector('a');
        if (first) first.focus();
      });
      mobileMenu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => closeMenu()));
      window.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenu({ returnFocus: true }); });
      window.addEventListener('scroll', updateScroll, { passive: true });
      updateScroll();

      if (!reduceMotion) {
        document.documentElement.classList.add('motion-ready');
        document.querySelectorAll('.hero-copy > *').forEach((el, index) => {
          el.style.setProperty('--hero-delay', `${80 + index * 90}ms`);
        });
        document.querySelectorAll('.workflow-track .step').forEach((el, index) => {
          el.style.setProperty('--reveal-delay', `${index * 120}ms`);
        });
        requestAnimationFrame(() => document.querySelector('.hero-copy')?.classList.add('visible'));
      }

      if (!reduceMotion && 'IntersectionObserver' in window) {
        const revealObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              revealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: .12, rootMargin: '0px 0px -40px' });
        document.querySelectorAll('[data-reveal]:not(.hero-copy)').forEach(el => revealObserver.observe(el));
      } else {
        document.querySelectorAll('[data-reveal]').forEach(el => el.classList.add('visible'));
      }

      if (!reduceMotion) {
        const featureImage = document.querySelector('.feature-media img');
        const dial = document.querySelector('.accuracy-dial');
        let motionFrame = 0;
        const updateAmbientMotion = () => {
          motionFrame = 0;
          const viewportCenter = window.innerHeight / 2;
          if (featureImage) {
            const rect = featureImage.parentElement.getBoundingClientRect();
            const shift = Math.max(-18, Math.min(18, (viewportCenter - (rect.top + rect.height / 2)) * .035));
            featureImage.style.setProperty('--media-shift', `${shift.toFixed(2)}px`);
          }
          if (dial) {
            const rect = dial.getBoundingClientRect();
            const shift = Math.max(-12, Math.min(12, (viewportCenter - (rect.top + rect.height / 2)) * .025));
            dial.style.setProperty('--dial-shift', `${shift.toFixed(2)}px`);
          }
        };
        const requestAmbientMotion = () => {
          if (!motionFrame) motionFrame = requestAnimationFrame(updateAmbientMotion);
        };
        window.addEventListener('scroll', requestAmbientMotion, { passive: true });
        window.addEventListener('resize', requestAmbientMotion);
        requestAmbientMotion();
      }

      const mobileBuy = document.querySelector('.mobile-buy');
      const heroActions = document.querySelector('.hero-actions');
      if (mobileBuy && heroActions && 'IntersectionObserver' in window) {
        const preorderSection = document.querySelector('.preorder');
        let heroActionsVisible = true;
        let preorderVisible = false;
        const syncMobileBuy = () => {
          const mobile = window.matchMedia('(max-width: 700px)').matches;
          mobileBuy.hidden = !mobile || heroActionsVisible || preorderVisible;
        };
        const stickyBuyObserver = new IntersectionObserver(([entry]) => {
          heroActionsVisible = entry.isIntersecting;
          syncMobileBuy();
        }, { threshold: 0, rootMargin: '-88px 0px 0px' });
        stickyBuyObserver.observe(heroActions);
        if (preorderSection) {
          const preorderObserver = new IntersectionObserver(([entry]) => {
            preorderVisible = entry.isIntersecting;
            syncMobileBuy();
          }, { threshold: 0 });
          preorderObserver.observe(preorderSection);
        }
      }

      const sectionLinks = [...document.querySelectorAll('.desktop-nav a[href^="#"]:not(.nav-cta)')];
      const sectionObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          sectionLinks.forEach(link => link.removeAttribute('aria-current'));
          const active = sectionLinks.find(link => link.getAttribute('href') === `#${entry.target.id}`);
          if (active) active.setAttribute('aria-current', 'location');
        });
      }, { rootMargin: '-35% 0px -55%' });
      document.querySelectorAll('main section[id]').forEach(section => sectionObserver.observe(section));
    })();

(() => {
      const v = document.getElementById('howtoVideo');
      const btn = document.getElementById('howtoPlay');
      const poster = document.getElementById('howtoPoster');
      if (!v || !btn) return;
      // the file is only fetched on demand: preload="none" until a real click
      const start = (t) => {
        if (typeof t === 'number' && !Number.isNaN(t)) {
          const seek = () => { v.currentTime = t; v.removeEventListener('loadedmetadata', seek); };
          v.readyState ? (v.currentTime = t) : v.addEventListener('loadedmetadata', seek);
        }
        v.hidden = false;
        btn.hidden = true;
        if (poster && poster.parentElement) poster.parentElement.hidden = true;
        const p = v.play();
        if (p && p.catch) p.catch(() => { /* autoplay refused; controls are visible */ });
      };
      btn.addEventListener('click', () => start());
      document.querySelectorAll('.howto-chapters [data-seek]').forEach(b =>
        b.addEventListener('click', () => start(parseFloat(b.dataset.seek))));
    })();
